/* eslint-disable no-shadow */
/*
 *
 * PaymentLinks reducer
 *
 */
import produce from 'immer';
import { DEFAULT_ACTION, ENABLE_LOADER, DISABLE_LOADER } from './constants';

export const initialState = {
  isLoading: false,
};

/* eslint-disable default-case, no-param-reassign */
const easySplitReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case ENABLE_LOADER: {
        draft.isLoading = true;
        break;
      }
      case DISABLE_LOADER: {
        draft.isLoading = false;
        break;
      }
      case DEFAULT_ACTION:
        break;
    }
  });

export default easySplitReducer;
